/* SKINPET · carrito UpCart (vive en Shadow DOM, por eso se inyecta el CSS y el HTML desde aquí):
   botón naranja, producto simplificado (solo cantidad y precio), ahorro destacado, garantía, envío gratis (línea simple) y medios de pago. */
(function () {
  var CSS =
    '.upcart-checkout-button,.upcart-checkout-button-container a,.upcart-checkout-button-container button{background:#ff8400!important;background-image:none!important;color:#fff!important;border:0!important;border-radius:999px!important;font-weight:600!important;box-shadow:rgba(0,0,0,.42) 3px 5px 8px!important}' +
    '.upcart-checkout-button-container{background:transparent!important;background-image:none!important;border:0!important;box-shadow:none!important;border-radius:999px!important}' +
    '.upcart-internal-component-product-tile__variant,.upcart-internal-component-product-tile__savings{display:none!important}' +
    '.upcart-internal-component-product-tile__price{font-size:21px!important;font-weight:800!important;color:#013984!important}' +
    '.upcart-internal-component-product-tile__price-compare-at{font-size:15px!important}' +
    '[data-skp-hide]{display:none!important}' +
    '#skp-cartg{display:grid;gap:8px;margin:10px 0;padding:0 2px;font-family:inherit}' +
    '.skp-s{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;border-radius:16px;background:#e8f7ee;border:2px solid #14a352;color:#0a5f2f}' +
    '.skp-s__l{display:block;font-size:13px;font-weight:700;line-height:1.2;text-transform:uppercase;letter-spacing:.03em}' +
    '.skp-s__d{display:block;margin-top:3px;font-size:12.5px;line-height:1.3;color:#146b3a}' +
    '.skp-s__v{flex:0 0 auto;font-size:26px;font-weight:800;line-height:1;color:#0a7a3d}' +
    '.skp-c{position:relative;overflow:hidden;display:flex;align-items:center;gap:12px;padding:11px 14px;border:1.5px solid transparent;border-radius:18px;color:#fff;background:radial-gradient(120% 140% at 15% 0%,#1d62b8 0%,#013984 55%,#00255a 100%) padding-box,linear-gradient(135deg,#fff 0%,#c9ced6 25%,#8d96a3 50%,#e8ebf0 75%,#aab1bc 100%) border-box;box-shadow:0 8px 18px rgba(1,40,100,.25)}' +
    '.skp-c::after{content:"";position:absolute;top:0;bottom:0;left:-60%;width:40%;background:linear-gradient(100deg,transparent,rgba(255,255,255,.28),transparent);transform:skewX(-18deg);animation:skpGsh 5.5s ease-in-out infinite;pointer-events:none}' +
    '.skp-c__i{flex:0 0 42px;width:42px;height:42px;padding:10px;box-sizing:border-box;border-radius:50%;border:2px solid transparent;background:radial-gradient(circle at 35% 30%,#2f7fe0,#0b4aa5 55%,#012b69) padding-box,linear-gradient(135deg,#fff,#aab1bc,#e8ebf0) border-box;box-shadow:0 4px 10px rgba(0,20,60,.4);fill:none;stroke:#fff;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}' +
    '.skp-c__t{position:relative;z-index:1;display:block;font-size:16px;font-weight:700;line-height:1.2;color:#fff}' +
    '.skp-c__s{position:relative;z-index:1;display:block;margin-top:2px;font-size:13px;line-height:1.3;color:#dbe9f7;font-weight:400}' +
    '#skp-ship{display:flex;align-items:center;justify-content:center;gap:8px;margin:0 0 8px;font-size:14px;font-weight:700;color:#013984}' +
    '#skp-ship svg{width:22px;height:22px;fill:none;stroke:#013984;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}' +
    '#skp-pay{display:flex;flex-wrap:wrap;justify-content:center;gap:6px;margin:10px 0 2px}' +
    '#skp-pay svg{width:38px;height:24px}' +
    '#skp-pay svg:has(#pi-paypal){display:none}' +
    '.upcart-internal-addons__content-price{flex:0 0 auto!important;white-space:nowrap!important}.upcart-internal-addons__price{white-space:nowrap!important}' +
    '.upcart-internal-addons__content-title-wrapper{flex-direction:column!important;align-items:flex-start!important;gap:2px!important}.upcart-internal-addons__content-title{font-size:15px!important;max-width:none!important}' +
    '.upcart-internal-addons__content-title{font-size:14px!important;line-height:1.25!important;white-space:nowrap!important}.upcart-internal-addons__image-wrapper{flex:0 0 52px!important;width:52px!important}.upcart-internal-addons__image-wrapper img{width:52px!important;height:auto!important}' +
    '#skp-cartg .skp-s__d{display:none!important}' +
    '#skp-cartg .skp-s{padding:14px 18px!important;border:1.5px solid transparent!important;border-radius:18px!important;color:#fff!important;background:radial-gradient(120% 140% at 15% 0%,#2fcf75 0%,#14a352 55%,#0b7a3c 100%) padding-box,linear-gradient(135deg,#fff 0%,#c9ced6 25%,#8d96a3 50%,#e8ebf0 75%,#aab1bc 100%) border-box!important;box-shadow:0 8px 18px rgba(11,122,60,.28)!important}' +
    '#skp-cartg .skp-s__l{color:#d9ffe8!important;font-size:13px!important;font-weight:700!important;letter-spacing:.08em!important}#skp-cartg .skp-s__v{color:#fff!important;font-size:30px!important;font-weight:800!important;text-shadow:0 2px 6px rgba(0,60,30,.35)!important}' +
    '@keyframes skpGsh{0%,55%{left:-60%}100%{left:130%}}' +
    '@media(prefers-reduced-motion:reduce){.skp-c::after{animation:none}}';
  var SHIELD = '<svg class="skp-c__i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>';
  var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>';
  var BLOCK =
    '<div id="skp-cartg">' +
    '<div class="skp-s" id="skp-s" hidden><div><span class="skp-s__l">Estás ahorrando</span><span class="skp-s__d" id="skp-s-d"></span></div><span class="skp-s__v" id="skp-s-v"></span></div>' +
    '<div class="skp-c">' + SHIELD + '<div><span class="skp-c__t">Garantía de 30 días</span><span class="skp-c__s">Si no notas una mejora te devolvemos el 100% de tu dinero.</span></div></div>' +
    '</div>';
  var SHIP = '<div id="skp-ship">' + TRUCK + '<span>Envío GRATIS a todo México</span></div>';

  var sr = null, timer = null, last = '', cmp = null;

  function inOurs(n) {
    var e = n && (n.nodeType === 1 ? n : n.parentElement);
    return !!(e && e.closest && (e.closest('#skp-cartg') || e.closest('#skp-pay') || e.closest('#skp-ship')));
  }

  function compareMap() {
    if (cmp) return Promise.resolve(cmp);
    return fetch('/products/skinpet-gotas-para-perros.js').then(function (r) { return r.json(); }).then(function (p) {
      cmp = {};
      p.variants.forEach(function (v) { cmp[String(v.id)] = v.compare_at_price || 0; });
      return cmp;
    }).catch(function () { cmp = {}; return cmp; });
  }

  function updateSavings() {
    Promise.all([fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }), compareMap()]).then(function (res) {
      var cart = res[0], map = res[1];
      var fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: cart.currency });
      var before = 0, now = 0;
      cart.items.forEach(function (it) {
        var c = Math.max(map[String(it.variant_id)] || 0, it.original_price);
        before += c * it.quantity;
        now += it.final_line_price;
      });
      var sav = sr && sr.querySelector('#skp-s');
      if (!sav) return;
      var saved = before - now;
      if (saved > 0) {
        sav.hidden = false;
        sr.querySelector('#skp-s-v').textContent = fmt.format(saved / 100);
        sr.querySelector('#skp-s-d').textContent = 'Antes ' + fmt.format(before / 100) + ' · Pagas ' + fmt.format(now / 100);
      } else { sav.hidden = true; }
    }).catch(function () {});
  }

  function place() {
    if (!sr) return;
    if (!sr.querySelector('#skp-style')) {
      var st = document.createElement('style');
      st.id = 'skp-style';
      st.textContent = CSS;
      sr.appendChild(st);
    }
    var slot = sr.querySelector('[class*="CartPreview__bottomModules"]');
    if (slot && !slot.querySelector('#skp-cartg')) {
      var old = sr.querySelector('#skp-cartg');
      if (old) old.remove();
      slot.insertAdjacentHTML('beforeend', BLOCK);
      last = '';
    }
    var btn = sr.querySelector('[class*="Footer__checkoutButton"]') || sr.querySelector('.upcart-checkout-button-container');
    if (btn && !sr.querySelector('#skp-ship')) btn.insertAdjacentHTML('beforebegin', SHIP);
    var tpl = document.getElementById('skp-pay-tpl');
    if (btn && tpl && !sr.querySelector('#skp-pay')) {
      btn.insertAdjacentHTML('afterend', '<div id="skp-pay" aria-label="Medios de pago">' + tpl.innerHTML + '</div>');
    }
    var divs = sr.querySelectorAll('[class*="CartPreview__body"] > div > div');
    for (var i = 0; i < divs.length; i++) {
      var d = divs[i];
      if (!d.hasAttribute('data-skp-hide') && !d.children.length && /^Envío gratis a todo México\s*·/.test(d.textContent.trim())) d.setAttribute('data-skp-hide', '');
    }
    var sig = Array.prototype.map.call(sr.querySelectorAll('.upcart-internal-cart-item'), function (li) { return li.textContent.replace(/\s+/g, ' '); }).join('|');
    if (sig !== last) { last = sig; updateSavings(); }
  }

  function attach(host) {
    sr = host.shadowRoot;
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) if (!inOurs(recs[i].target)) { clearTimeout(timer); timer = setTimeout(place, 80); return; }
    }).observe(sr, { childList: true, subtree: true, characterData: true });
    place();
  }

  var poll = setInterval(function () {
    var h = document.getElementById('upCart');
    if (h && h.shadowRoot) { clearInterval(poll); attach(h); }
  }, 300);
  setTimeout(function () { clearInterval(poll); }, 60000);
})();
